import { render, staticRenderFns } from "./widgetColumns.vue?vue&type=template&id=0ac8bdff"
import script from "./widgetColumns.vue?vue&type=script&lang=js"
export * from "./widgetColumns.vue?vue&type=script&lang=js"
import style0 from "./widgetColumns.vue?vue&type=style&index=0&id=0ac8bdff&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports